module.exports = __webpack_public_path__ + "static/TruenoBd-dadef6fee100fa652d2a26dbfdcd8473.woff2";